import { render, staticRenderFns } from "./BlogTypesSelector.vue?vue&type=template&id=4004a571&"
import script from "./BlogTypesSelector.vue?vue&type=script&lang=js&"
export * from "./BlogTypesSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports